import { createAction, props } from "@ngrx/store";
import { UserSettings } from "./services/models/userData.model";
import { CountryList } from "./services/countriesList.model";

export const appInit = createAction('[App] App Init');

export const userDataSuccess = createAction('[App] User Data Success', props<{ result: UserSettings}>());

export const userDataFailure = createAction('[App] User Data Error', props<{ error: string}>());

export const updateUserSettings = createAction('[App] Update User Settings', props<{ settings: Partial<UserSettings>}>());

export const updateUserSettingsSuccess = createAction('[App] Update User Settings Success');

export const updateUserSettingsFailure = createAction('[App] Update User Settings Failure', props<{ error: string}>());

export const countryListSuccess = createAction('[App] Country List Success', props<{ result: CountryList[]}>());

export const countryListFailure = createAction('[App] Country List Failure', props<{ error: string}>());